export const REQUEST_REGISTER = 'REQUEST_REGISTER',
      REQUEST_UNREGISTER = 'REQUEST_UNREGISTER'
